import React from 'react';
import styled from '@emotion/styled';

const AreaHighlightCardSkeletonsWrapper = styled.div`
  position: relative;
  display: flex;
  padding-left: 24px;
  margin-top: 20px;
`;

const AreaHighlightCardSkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  background: ${({ theme }) => theme.colors.neutrals.white};
  border-radius: ${({ theme }) => theme.borderRadius.small};
  padding: 20px;
  box-shadow: ${({ theme }) => theme.shadow.level2};
  height: 162px;
  margin-right: 24px;

  ${({ theme }) => theme.media.showAt({ from: 2, to: 5 })`
    width: 261px;
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    width: 230px;
  `}

  ${({ theme }) => theme.media.showAt({ to: 2 })`
    height: 192px;
  `}

  div:first-of-type {
    width: 32px;
    height: 32px;
    border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
    background: ${({ theme }) => theme.colors.neutrals.grey9};
  }

  div:nth-of-type(2) {
    width: 100%;
    height: 20px;
    border-radius: ${({ theme }) => theme.borderRadius.tiny};
    background: ${({ theme }) => theme.colors.neutrals.grey9};
  }
`;

interface AreaHighlightCardSkeletonProps {
  itemsNumber: number;
}

export const AreaHighlightCardSkeleton: React.FC<AreaHighlightCardSkeletonProps> = ({ itemsNumber }) => (
  <AreaHighlightCardSkeletonsWrapper>
    {
      new Array(itemsNumber).fill(null).map((_, index) => (
        <AreaHighlightCardSkeletonWrapper key={index}>
          <div/>
          <div/>
        </AreaHighlightCardSkeletonWrapper>
      ))
    }
  </AreaHighlightCardSkeletonsWrapper>
);
